/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { requisitionConfirmationTotalStyles } from "@monsma/Overrides/Widgets/RequisitionConfirmation/RequisitionConfirmationTotal";
import { css } from "styled-components";

requisitionConfirmationTotalStyles.xRequisitionConfirmationTotalStyles = {
    wrapper: {
        css: css`
            background: ${getColor("common.background")};
            border: 1px solid ${getColor("common.ui12")};
            border-radius: 0 0 6px 6px;
            overflow: hidden;
            position: relative;
        `,
    },
    title: {
        variant: "h6",
        lineHeight: "20px",
        color: "text.inverse",
        css: css`
            margin-bottom: 0;
            background: ${getColor("common.ui1")};
            color: white;
            padding: 15px;
            border-radius: 6px 6px 0 0;
        `,
    },
    itemsCount: {
        variant: "h6",
        lineHeight: "20px",
        css: css`
            margin: 0 20px;
            padding: 15px 0;
            border-bottom: 1px solid ${getColor("common.ui12")};
        `,
    },
};
